export const AWS_BUCKET_URL = 'https://figk-dev.s3.ap-northeast-2.amazonaws.com/'

export const nonAccessCopy = (e: Event) => {
    e.preventDefault()
}
